import { render } from "./Nongchanpin.vue?vue&type=template&id=2046a47f&scoped=true"
import script from "./Nongchanpin.vue?vue&type=script&lang=js"
export * from "./Nongchanpin.vue?vue&type=script&lang=js"

import "./Nongchanpin.vue?vue&type=style&index=0&id=2046a47f&scoped=true&lang=css"

import exportComponent from "E:\\新建文件夹\\简策demo\\V策财经\\V策财经web-push\\vce-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2046a47f"]])

export default __exports__